import { Component, OnInit, Input, ViewChild, EventEmitter, Output, TemplateRef, HostListener, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { download, LeadgetPageSize, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { CommonService } from 'src/app/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { RestrictionComponent } from 'src/app/shared/restriction-pop-up/restriction/restriction.component';
import { ImportExcelComponent } from 'src/app/pages/commonImport/import-excel/import-excel.component';
import { CommonDownloadComponent } from 'src/app/pages/common-download/common-download.component';
import { CurrencyPipe, DatePipe, Location } from '@angular/common';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import * as XLSX from 'xlsx';
import { TransferLeadComponent } from 'src/app/shared/transfer-lead/transfer-lead.component';
import { DealsService } from 'src/app/services/deals.service';
import { DealskanbanComponent } from '../dealskanban/dealskanban.component';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { AddDealsPaymentComponent } from './add-deals-payment/add-deals-payment.component';
import { ViewDealsPaymentComponent } from './view-deals-payment/view-deals-payment.component';
import { CrmBusinessEditComponent } from 'src/app/shared/crm-business-edit/crm-business-edit.component';
import { UsersService } from 'src/app/services/users.service';

import { CrmSearchComponent } from 'src/app/shared/crm-search/crm-search.component';
import { LoaderService } from 'src/app/services/loader.service';
import { ConversationPopupComponent } from 'src/app/shared/conversation-popup/conversation-popup.component';
import { CrmNoteComponent } from 'src/app/shared/crm-note/crm-note.component';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { EmailPopupComponentComponent } from '../lead-detail/email-popup-component/email-popup-component.component';
import { FileUploadPopupComponent } from '../../file-upload-popup/file-upload-popup.component';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { CompaniesService } from 'src/app/services/companies.service';
import { ProductService } from 'src/app/services/product.service';
import { AddMeetingComponent } from '../../companies/add-meeting/add-meeting.component';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { CurrencyConvertPipe } from 'src/app/shared/pipes/currency-convert.pipe';
import { SmartViewsService } from 'src/app/services/smart-views.service';
import { DealsGridService } from 'src/app/services/deals-grid.service';

/** Shape of the structured JSON stored in localStorage for GridType 8 */
interface DealsTableConfig {
  name: string;
  url: string;
  data: { [columnName: string]: number };
}

/** Single localStorage key that holds ALL column widths for the deals table (GridType 8) */
const DEALS_TABLE_CONFIG_KEY = 'dealsTableConfig';

import icWhatsapp from '@iconify/icons-mdi/whatsapp';
import { DealEditPageComponent } from './deal-edit-page/deal-edit-page.component';

@Component({
  selector: 'calsoft-deals',
  templateUrl: './deals.component.html',
  styleUrls: ['./deals.component.scss'],
  providers: [CurrencyPipe, CurrencyConvertPipe]
})
export class DealsComponent implements OnInit, OnDestroy {

  icWhatsapp = icWhatsapp;
  url = '';
  sanitizedUrl = '';
  leadDetailPageType: any = [];
  leadDetailType: any = 0;

  @Input() type: any = 1;
  @Input() leadId: any = 0;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  productList: any;
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  secondFormGroup: any;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterActive: boolean = false;
  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  pageIndex: any;
  pageSize: number;
  pageList: any;
  spinner: boolean;
  search: any;
  id: any;
  pageSizeValue: any;
  resourcePrivilege: any;
  elements: any
  setList: any = [];
  read: any = false;
  serverPath: any = environment.ImageAPI;
  downloadDataComplete: string;
  create: any;
  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;
  configurableProductDropdown: any;
  configattributeType: any;
  productSelected: any;

  @Input() primaryTitle = 'Product';

  @Input() dealsPrimaryType: number = 0;

  @Input() secondaryType = 1;
  @Input() DealType = 1;
  urlPage: any;
  urlSize: any;
  urlSort: string;
  redirected: boolean = false;
  crmType: any;
  initCrmType: boolean = false;
  useDefaultHeading: any = false;
  selectUpload: boolean = false;
  isMobile: boolean = window.innerWidth <= 768;
  totaldealsCount: any;
  totalElements: number = 0;
  columnsProperties: string[] = [];
  leadList: any = [];
  totalNewdealsCount: any = 0;
  configData: any;
  GridType: any = 1;
  dealGridType: any = 1;
  customDealGridType: any;
  filterType: any;
  storename: any;
  totalLeadCount: any;
  newContactCount: any;

  @HostListener('window:resize', [])
  onResize() {
    this.isMobile = window.innerWidth <= 768;
  }

  currentRouterPath: any;
  @Input() dealsTableView: number = 0;

  dialerType: any;
  data: Object;
  templateDisplayed: any;
  noteList: any = [];

  filterSelectObj: any[] = [
    {
      name: 'Select',
      property: 'disable',
      type: 'disable',
      position: 'firstValue',
      options: [],
    },
    {
      name: 'Deals Name',
      property: 'dealsName',
      type: 'text',
      position: 'secondValue',
      options: []
    },
    {
      name: 'Product',
      property: 'product',
      type: 'text',
      position: 'thirdValue',
      options: []
    },
    {
      name: 'Stage',
      property: 'stage',
      type: 'multiSelect',
      position: 'fourthValue',
      options: []
    },
    {
      name: 'Deal Value',
      property: 'amount$n',
      type: 'text',
      position: 'fifthValue',
      options: []
    },
    {
      name: 'Lead Name',
      property: 'leadName',
      type: 'text',
      position: 'sixthValue',
      options: []
    },
    {
      name: 'Owner',
      property: 'dealsOwner',
      type: 'multiSelect',
      position: 'seventhValue',
      options: []
    },
    {
      name: 'Closing Date',
      property: 'closingDate',
      type: 'date',
      position: 'eightValue',
      options: []
    },
    {
      name: 'Expected Closing Date',
      property: 'expectedClosingDate',
      type: 'date',
      position: 'ninthValue',
      options: []
    },
    {
      name: 'Lead Created Date',
      property: 'leadCreatedDate',
      type: 'date',
      position: 'TenthValue',
      options: []
    },
    {
      name: 'Created Date',
      property: 'createdDate',
      type: 'date',
      position: 'eleventhValue',
      options: []
    },
    {
      name: 'Updated Date',
      property: 'updatedDate',
      type: 'date',
      position: 'twelevthValue',
      options: []
    },
    {
      name: 'Payment Status',
      property: 'paymentStatus',
      type: 'multiSelect',
      position: 'thirteenthValue',
      options: [
        { viewValue: 'Pending', value: 'Pending' },
        { viewValue: 'Partial', value: 'Partial' },
        { viewValue: 'Paid', value: 'Paid' }
      ]
    },
  ];

  buildFilterSelectObjFromColumns(cols: ListColumn[]) {
    const positionNames = [
      'firstValue', 'secondValue', 'thirdValue', 'fourthValue', 'fifthValue',
      'sixthValue', 'seventhValue', 'eightValue', 'ninthValue', 'TenthValue',
      'eleventhValue', 'twelevthValue', 'thirteenthValue', 'fourteenthValue',
      'fifteenthValue', 'sixteenthValue', 'seventeenthValue', 'eighteenthValue'
    ];

    if (!cols || !cols.length) {
      return;
    }

    const filterObj: any[] = [];

    filterObj.push({
      name: 'Select',
      property: 'disable',
      type: 'disable',
      position: positionNames[0],
      options: []
    });

    let posIndex = 1;
    cols.forEach((col: any) => {
      let prop = col.property || col.attributeCode;
      let colName = col.name || col.label || prop;

      if (!prop || prop === 'select' || prop === 'actions' || prop === 'action' || prop === 'disable') {
        return;
      }

      let type = 'text';
      let targetProp = prop;

      if (
        prop === 'owner' || prop === 'Owner' || prop === 'dealsOwner' || prop === 'ownerEmail' ||
        col.attributeCode === 'ownerEmail' || col.propertyName === 'ownerEmail' ||
        prop === 'stage' || prop === 'Deal Stage' || prop === 'paymentStatus'
      ) {
        type = 'multiSelect';
        if (
          prop === 'owner' || prop === 'Owner' || prop === 'ownerEmail' ||
          col.attributeCode === 'ownerEmail' || col.propertyName === 'ownerEmail'
        ) {
          targetProp = 'dealsOwner';
        }
      } else if (prop === 'amount' || prop === 'dealValue' || prop === 'amount$n') {
        type = 'text';
        targetProp = 'amount$n';
      } else if (
        prop.toLowerCase().includes('date') ||
        col.frontendInput === 'date' ||
        col.type === 'date'
      ) {
        type = 'date';
      } else if (col.optionValues && col.optionValues.length > 0) {
        type = 'multiSelect';
      }

      let colOptions = col.optionValues || [];
      if ((prop === 'paymentStatus' || colName.toLowerCase() === 'payment status') && (!colOptions || !colOptions.length)) {
        colOptions = [
          { viewValue: 'Pending', value: 'Pending' },
          { viewValue: 'Partial', value: 'Partial' },
          { viewValue: 'Paid', value: 'Paid' }
        ];
      }

      filterObj.push({
        name: colName,
        property: targetProp,
        type: type,
        position: positionNames[posIndex] || `val_${posIndex}`,
        options: colOptions
      });

      posIndex++;
    });

    this.filterSelectObj = filterObj;
  }

  columnWidths: { [key: string]: number } = {};

  // ─── GridType 8 Structured localStorage Helpers ─────────────────────────────

  /**

   * @param columnName  The column property name (e.g. 'name', 'createdDate')
   * @param width       The new width in pixels
   */
  saveColumnSize(columnName: string, width: number): void {
    try {
      const existing = localStorage.getItem(DEALS_TABLE_CONFIG_KEY);
      const config: DealsTableConfig = existing
        ? JSON.parse(existing)
        : { name: 'deals', url: this.router.url, data: {} };

      // Ensure the data bucket always exists
      if (!config.data) {
        config.data = {};
      }

      // Update only the modified column — leave all others intact
      config.data[columnName] = width;

      localStorage.setItem(DEALS_TABLE_CONFIG_KEY, JSON.stringify(config));
    } catch (err) {
      console.error('[dealsTableConfig] Failed to save column size:', err);
    }
  }

  /**
   * Retrieves all stored column widths for the deals table.
   * Returns an empty object when no config is found or parsing fails.
   * Scoped exclusively to GridType 8.
   */
  getColumnSizes(): { [columnName: string]: number } {
    try {
      const stored = localStorage.getItem(DEALS_TABLE_CONFIG_KEY);
      if (!stored) return {};
      const config: DealsTableConfig = JSON.parse(stored);
      return config?.data ?? {};
    } catch (err) {
      console.error('[dealsTableConfig] Failed to read column sizes:', err);
      return {};
    }
  }

  // ─────────────────────────────────────────────────────────────────────────────

  onColumnResized(column: string, width: number): void {
    this.columnWidths[column] = width;

    if (this.GridType >= 8) {
      this.saveColumnSize(column, width);
    }
  }



  constructor(
    private dealsService: DealsService,
    private loaderService: LoaderService,
    private ecryptService: EcryptServiceService,
    private router: Router,
    private commonService: CommonService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private location: Location,
    private route: ActivatedRoute,
    private dataPipe: DatePipe,
    private crmsettingsService: CrmsettingsService,
    private cdr: ChangeDetectorRef,
    private usersService: UsersService,
    private leadActivityService: LeadActivityService,
    private crmNoteService: CrmNoteService,
    private companiesService: CompaniesService,
    private productService: ProductService,
    private dealsStageService: DealsStageService,
    public currencyConvertPipe: CurrencyConvertPipe,
    private smartViewsService: SmartViewsService,
    private dealsGridService: DealsGridService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.currentRouterPath = this.router.url;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  @ViewChild(DealskanbanComponent) dealsKanban: DealskanbanComponent;

  /**
   * If kanban view is present and active, trigger a refresh on the kanban child so it picks up
   * latest filters/search state.
   */
  private notifyKanbanUpdate(): void {
    try {
      // tableViewMode or viewType may control which kanban instance is shown in the template
      const shouldRefresh = (this.viewType === 'kanban') || (this.tableViewMode === 'kanbanView');
      if (shouldRefresh && this.dealsKanban && typeof this.dealsKanban.getDealStatus === 'function') {
        this.dealsKanban.getDealStatus();
      }
    } catch (e) {
      // swallow errors to avoid breaking data flow
      console.warn('Failed to refresh deals kanban:', e);
    }
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  isLeadViewSelected: boolean = false;

  viewType: string = 'leadview';

  selectView(view: string) {
    this.isLeadViewSelected = view === 'leadView';
    this.viewType = view; // Update viewType so that the display changes accordingly
  }


  switchView(type: string) {
    this.viewType = type;
    if (this.viewType === 'kanban') {

    }
  }

  mapperMap = new Map<string, string>();

  smartViewConditionsEnble: boolean = false

  @ViewChild('tabsScroll', { static: false }) tabsScroll!: ElementRef;

  @Input() columns: ListColumn[] = []

  columnsReady: boolean = false;

  columnsVisble: ListColumn[];

  ngOnInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        localStorage.removeItem("dealsActiveTab");
        localStorage.removeItem("dealsSmartViewConditionsEnble");
      }
    });

    this.ensureSmartViewFromFilter();

    const storedViewMode: any = localStorage.getItem('dealsViewMode');

    if (storedViewMode !== null && storedViewMode !== '') {
      this.tableViewMode = storedViewMode;
      this.viewMode = 'compact';
    } else {
      this.tableViewMode = this.router.url.includes('deals')
        ? 'kanbanView'
        : 'tableView';
      this.viewMode = 'compact';
      localStorage.setItem('dealsViewMode', this.tableViewMode);
    }




    this.getUserDropDownList();

    this.checkScreen();
    window.addEventListener('resize', () => this.checkScreen());
    this.route.queryParams.subscribe(params => {
      const fromTour = params['fromTour'];

      if (fromTour) {
        localStorage.removeItem("userCreated");

      }
    });
    const encryptedConfig = localStorage.getItem('configSettingsData')

    this.advanceFilterEnble = localStorage.getItem('advanceFilterEnble') === 'true';

    this.getALLSmartViewsNew();

    if (encryptedConfig) {

      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        this.configData = JSON.parse(decrypted);
        this.GridType = this.configData.gridType;
        this.filterType = this.configData.filterType;
        this.storename = this.configData.storeName;


      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    if (this.GridType >= 8) {
      const savedSizes = this.getColumnSizes();
      if (Object.keys(savedSizes).length > 0) {
        this.columnWidths = { ...savedSizes };
      }
    }

    this.getAllCrmData();
    this.getLeadStatusList();
    this.LeadStatusYFilter();

    this.textAccount = 'OK';
    this.textAccountHousing = 'OK';
    this.downloadDataComplete = 'OK';
    this.urlPage = this.route.snapshot.queryParamMap.get("page")
    this.urlSize = this.route.snapshot.queryParamMap.get("size")
    this.urlSort = this.route.snapshot.queryParamMap.get("sort")

    if (this.urlPage != null) {

      this.page = this.urlPage
    }

    if (this.urlSize != null) {

      this.size = this.urlSize
    }

    if (this.urlSort != null) {

      this.sortParam = this.urlSort.replace('$n', '')
    }
    this.getResource();

    if (this.urlPage != null) {
      this.redirected = true;
    }
    if (this.dealsTableView == 1) {
      this.tableViewMode = 'tableView';
    }

    if (this.smartViewConditionsEnble) {
      const activeTab = localStorage.getItem('dealsActiveTab');
      this.scrollAndActivateTabByLabel(activeTab, 'none');
    }

  }


  getAllCrmData() {

    this.ensureSmartViewFromFilter();

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {


          this.dealGridType = data['dealGridType'];

          this.customDealGridType = data['customDealGridType'];
          this.leadDetailPageType = data['leadDetailPageType'];
          this.initCrmType = true;

          if (this.initCrmType = true) {

            if (this.dealGridType == 1) {

              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Deals Name', property: 'dealsName', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Product', property: 'product', visible: true, isModelProperty: true, isSticky: true },
                { name: 'Deal Value', property: 'amount', visible: true, isModelProperty: false },
                { name: 'Deal Stage', property: 'stage', visible: true, isModelProperty: false },
                { name: 'Sales Owner', property: 'dealsOwner', visible: true, isModelProperty: true },
                { name: 'Closing Date', property: 'closingDate', visible: true, isModelProperty: false },
                { name: 'Expected Closing Date', property: 'expectedClosingDate', visible: true, isModelProperty: false },
                { name: 'Lead Created Date', property: 'leadCreatedDate', visible: true, isModelProperty: false },
                { name: 'Lead Name', property: 'leadName', visible: true, isModelProperty: true },
                { name: 'Company Name', property: 'company', visible: true, isModelProperty: true },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Reason For Loss', property: 'reasonForLoss', visible: false, isModelProperty: true },
              ] as ListColumn[];
              this.buildFilterSelectObjFromColumns(this.columns);
            } else if (this.dealGridType == 2) {

              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Deals Name', property: 'dealsName', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Product', property: 'product', visible: true, isModelProperty: true, isSticky: true },
                { name: 'Lead Name', property: 'leadName', visible: true, isModelProperty: true },
                { name: 'Amount', property: 'amount', visible: true, isModelProperty: false },
                { name: 'Probability', property: 'probability', visible: true, isModelProperty: true },
                { name: 'Stage', property: 'stage', visible: true, isModelProperty: false },
                { name: 'Closing Date', property: 'closingDate', visible: true, isModelProperty: false },
                { name: 'Expected Closing Date', property: 'expectedClosingDate', visible: true, isModelProperty: false },
                { name: 'Lead Created Date', property: 'leadCreatedDate', visible: true, isModelProperty: false },
                // { name: 'Contact Name', property: 'contactName', visible: true, isModelProperty: true },
                { name: 'Paid', property: 'paid', visible: true, isModelProperty: false },
                { name: 'Balance', property: 'balance', visible: true, isModelProperty: false },
                {
                  name: 'Payment Status',
                  property: 'paymentStatus',
                  visible: true,
                  isModelProperty: false,
                  optionValues: [
                    { viewValue: 'Pending', value: 'Pending' },
                    { viewValue: 'Partial', value: 'Partial' },
                    { viewValue: 'Paid', value: 'Paid' }
                  ]
                },
                // { name: 'Related Account', property: 'company', visible: true, isModelProperty: false },
                // { name: 'Related Lead', property: 'lead', visible: true, isModelProperty: false },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

              this.columnsVisble = [...this.columns];

              this.columnsVisble = this.columns.filter(col => col.name !== 'Action' && col.name !== 'select');
              this.buildFilterSelectObjFromColumns(this.columns);

            } else if (this.dealGridType == 3) {

              this.getGridById(this.customDealGridType);
              this.columnsProperties = this.columns.map(col => col.property);
              this.columnsReady = true;
            } else {
              this.columns = [
                { name: 'select', property: 'select', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Deals Name', property: 'dealsName', visible: true, isModelProperty: false, isSticky: true },
                { name: 'Product', property: 'product', visible: true, isModelProperty: true, isSticky: true },
                { name: 'Deal Value', property: 'amount', visible: true, isModelProperty: false },
                { name: 'Deal Stage', property: 'stage', visible: true, isModelProperty: false },
                { name: 'Sales Owner', property: 'dealsOwner', visible: true, isModelProperty: true },
                { name: 'Closing Date', property: 'closingDate', visible: true, isModelProperty: false },
                { name: 'Expected Closing Date', property: 'expectedClosingDate', visible: true, isModelProperty: false },
                { name: 'Lead Created Date', property: 'leadCreatedDate', visible: true, isModelProperty: false },
                { name: 'Lead Name', property: 'leadName', visible: true, isModelProperty: true },
                { name: 'Company Name', property: 'company', visible: true, isModelProperty: true },
                { name: 'created Date', property: 'createdDate', visible: true, isModelProperty: false },
                { name: 'updated Date', property: 'updatedDate', visible: true, isModelProperty: false },
                { name: 'Reason For Loss', property: 'reasonForLoss', visible: false, isModelProperty: true },
                { name: 'Renewal Date', property: 'renewalDate', visible: false, isModelProperty: true },
                { name: 'Action', property: 'actions', visible: true, disabled: true },
              ] as ListColumn[];

            }

            if (this.redirected == true) {
              this.urlPage = this.route.snapshot.queryParamMap.get("page")
              this.urlSize = this.route.snapshot.queryParamMap.get("size")
              this.urlSort = this.route.snapshot.queryParamMap.get("sort")
              if (this.urlPage != null) {
                this.redirected = true;

                this.page = this.urlPage;
                this.size = this.urlSize;
                this.sortParam = this.urlSort;
              }
              this.firstFormGroup.value.page = this.page;
              this.firstFormGroup.value.size = this.size;
            }
            if (this.sortParam.split(",")[0] == 'entityId') {
              this.firstFormGroup.value.sort = 'dealsName';
            } else {
              this.firstFormGroup.value.sort = this.sortParam.split(",")[0]
            }

          }
          this.read = this.resourcePrivilege?.read;
        } else {

          this.crmType = 1;

        }


      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }


    }




  }


  bulkUpload: boolean = false;
  _form: UntypedFormGroup;


  checkScreen() {
    this.isMobile = window.innerWidth <= 768; // adjust breakpoint as needed
  }

  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.DEALS)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          if (data.restriction.length > 0) {
            this.bulkUpload = data.restriction[0].bulkUpload == 1 ? true : false;
            this.productLimitedRestrictionValue = data.restriction[0].productLimitedRestriction;
            this.productLimitedRestriction = true;
          } else {
            this.productLimitedRestriction = false;
          }
          this.read = data.read;
          this.resourcePrivilege = data;

          const url = this.router.url;
          const cleanUrl = url.split('?')[0];
          const searchTerm = localStorage.getItem(cleanUrl + "se");
          const type = localStorage.getItem(cleanUrl + "type");
          const filterSelectedValue = localStorage.getItem(cleanUrl + "filter");

          const hasActiveSearch = searchTerm != null && (type === "1" || type === "2");

          if (this.smartViewConditionsEnble == true) {
            this.getDynamicDealsReport(null);
          } else if (!hasActiveSearch) {
            this.getProduct();
          }

          if (filterSelectedValue != null) {
            this.columns = JSON.parse(localStorage.getItem(cleanUrl + "filter"));
          }
          if (type == "2" && searchTerm != null) {

            this.filterActive = true;
            this.search = searchTerm;
            this.search = this.search.replace(/'/g, '');

            // Directly call filterOption for CRM search, bypassing supplier filter logic
            this.filterOption(this.search);


          } else if (type == "1" && searchTerm != null) {

            this.filterActive = true;
            this.search = searchTerm;
            this.search = this.search.replace(/'/g, '');

            this.onFilterChange(this.search, 2);
          }
          else {

          }

        }
      });
  }


  goToPopUp() {
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmSearchComponent, {
        width: '80%',
        maxWidth: '1200px',
        height: '100%',
        data: {

        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
    } else {
      const dialogRef = this.dialog.open(CrmSearchComponent, {
        minWidth: '100vw', height: '100vh',
        data: {

        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
    }
  }



  getProduct() {
    this.firstFormGroup.value.sortBy = this.sortParam.split(",")[1]
    this.firstFormGroup.patchValue(this.firstFormGroup.value)
    this.filterActive = false;
    this.spinner = true;
    if (this.sortParam == undefined) {
      this.sortParam = 'updatedDate' + "," + Constant.Dsc;
    }
    if (this.DealType == 2) {

      this.dealsService.getAllDealssByEntityId(this.page, this.size, this.sortParam, this.leadId).subscribe(
        res => {
          this.notifyKanbanUpdate();
          this.loaderService.hide();
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.productList.sort = this.sort;
          this.pageList = res['totalElements'];
          this.productList.paginator = this.paginator;
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.syncSelectionOnDataLoad();
          this.cdr.detectChanges();
          this.totalElements = res['totalElements'];
          this.totaldealsCount = res['totalElements'];
          this.notifyKanbanUpdate();


        },
        error => {
          this.loaderService.hide();
          this.spinner = false;
        }
      )
    }
    else {
      if (this.sortParam == undefined) {
        this.sortParam = 'updatedDate' + "," + Constant.Dsc;
      }
      this.dealsService.getDeals(this.page, this.size, this.sortParam, this.type, this.leadId).subscribe(
        res => {
          this.notifyKanbanUpdate();
          this.loaderService.hide();
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.productList.sort = this.sort;
          this.pageList = res['totalElements'];
          this.productList.paginator = this.paginator;
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.syncSelectionOnDataLoad();
          this.cdr.detectChanges();
          this.totalElements = res['totalElements'];
          this.totaldealsCount = res['totalElements'];


        },
        error => {
          this.loaderService.hide();
          this.spinner = false;
        }
      )
    }

  }

  getUpdate(event) {
    this.selection.clear();
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');

    if (questionMarkIndex !== -1) {
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localtion = localtion.split('&page')[0]

    //  this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.DetectingRequestType();
  }

  sortData(event) {

    if (event.active.includes('customValuesIs')) {


      let originalString = event.active;
      let updatedString = originalString.replace('customValuesIs', '');

      updatedString = updatedString.replace(/\s/g, "_").replace(/\(/g, '_').replace(/\)/g, '_');
      updatedString = updatedString + "_cust"
      event.active = updatedString;

    }

    if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {

      if (this.size != Constant.SIZE) {

        this.size = this.size;

      } else {
        this.size = Constant.SIZE;
      }
      this.page = Constant.PAGE;

      this.sortParam = event.active.replace('$n', '');

      if (event.direction.length > 0) {

        if (this.mapperMap.get(event.active) != null) {
          if (event.direction == 'asc') {
            this.sortParam = this.mapperMap.get(event.active);
            this.sortParam = this.sortParam + "," + Constant.Asc;
          } else if (event.direction == 'desc') {
            this.sortParam = this.mapperMap.get(event.active);
            this.sortParam = this.sortParam + "," + Constant.Dsc;
          }
        }
        else {
          if (event.direction == 'asc') {
            this.sortParam = this.sortParam + "," + Constant.Asc;
          } else if (event.direction == 'desc') {
            this.sortParam = this.sortParam + "," + Constant.Dsc;
          }
        }
        let localtion = this.router.url;
        const questionMarkIndex = localtion.indexOf('?');

        if (questionMarkIndex !== -1) {
          // Extract the substring before the ?
          const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

          // Replace the original string with the substring before the ?
          localtion = beforeQuestionMark;
        }

        let url = this.router.url;
        let cleanUrl = url.split('?')[0];

        localtion = localtion.split('&page')[0]
        //  this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

        this.redirected = false;
        this.DetectingRequestType();
      }


    }

  }


  getLeadAdvanceFilter() {

    let sortParam: any = 'a.updatedDate' + "," + Constant.Dsc;



    if (this.advance.conditions !== null && this.advance.conditions !== undefined && this.advance.conditions !== '') {
      this.condition = this.advance.conditions;
    } else {
      this.condition = JSON.parse(localStorage.getItem('filtercondition'));
    }

    this.advanceFilterEnble = localStorage.getItem('advanceFilterEnble') === 'true';


    if (this.advanceFilterEnble == true) {

      this.filterActive = false;
      this.spinner = true;
      this.leadActivityService.searchLeadAdvanceFilterNew(null, this.page, this.size, sortParam, this.condition).subscribe(
        res => {
          // notify kanban to refresh when filters/search updated
          this.notifyKanbanUpdate();
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.productList.sort = this.sort;
          this.productList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.syncSelectionOnDataLoad();

          console.log(this.productList);

        },
        () => {
          this.spinner = false;
        }
      )

    } else {
      this.getProduct();
    }


  }


  DetectingRequestType() {
    if (!this.filterActive) {

      if (this.advanceFilterEnble == true) {
        this.getLeadAdvanceFilter()
      } else if (this.smartViewConditionsEnble == true) {
        this.getDynamicDealsReport(null)
      } else {
        this.getProduct();
      }


    }
    else {

      console.log("here pagination");

      if (this.advanceFilterEnble == true) {
        this.getAllLeadAdvanceFilter(this.search)
      } else if (this.smartViewConditionsEnble == true) {
        this.getDynamicDealsReport(this.search)
      } else {
        this.filterOption(this.search);
      }



    }
  }


  filterOption(event) {
    if (this.redirected == true) {
      this.urlPage = this.route.snapshot.queryParamMap.get("page")
      this.urlSize = this.route.snapshot.queryParamMap.get("size")
      this.urlSort = this.route.snapshot.queryParamMap.get("sort")
      if (this.urlPage != null) {
        this.redirected = true;

        this.page = this.urlPage;
        this.size = this.urlSize;
        if (this.urlSort != null) {
          this.sortParam = this.sort;
        } else {
          this.sortParam = 'updatedDate' + "," + Constant.Dsc;
        }

      }
      this.firstFormGroup.value.page = this.page;
      this.firstFormGroup.value.size = this.size;
    }
    this.filterActive = true;
    this.search = event;

    let url = this.router.url;
    if (url.includes('deals')) {
      let cleanUrl = url.split('?')[0];
      if (this.search) {
        localStorage.setItem(cleanUrl + "se", this.search);
      } else {
        localStorage.removeItem(cleanUrl + "se");
      }
    }

    if (this.type == 2) {

      this.search = `${this.search}`
    }

    if (this.sortParam == undefined) {
      this.sortParam = 'updatedDate' + "," + Constant.Dsc;
    }

    this.spinner = true;
    this.dealsService.getDealsBySearchMain(this.search, this.page, this.size, this.sortParam, this.leadId).subscribe(
      res => {
        this.spinner = false;


        if (!this.selectUpload) {
          this.productList = res['content'];
          this.elements = res['numberOfElements'];
          this.pageList = res['totalElements'];
          this.totalElements = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);
          this.syncSelectionOnDataLoad();
          // notify kanban to refresh when filters/search updated
          this.notifyKanbanUpdate();
        } else {
          this.downloadDataFinal(res['content'])
        }

      },
      error => {
        this.spinner = false;
      })

  }
  applyFilter(filterValue: string) {
    this.productList.filter = filterValue.trim().toLowerCase();
  }

  addproduct() {
    let dealId = 0;

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        let setId = data['defaultDealsSet'];


        localStorage.setItem('dealsViewMode', this.tableViewMode || 'tableView');
        if (this.type == 1) {

          this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
        } else {
          this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}/${this.leadId}`])
        }
      } catch (error) {
        console.error('Error decrypting or parsing userSettingsData:', error);
      }

    }
  }


  onFilterChange(value, index) {
    if (value == '') {
      this.leadIdList = [];
      this.selectionLead = [];
      let localtion = this.router.url;

      if (this.smartViewConditionsEnble == true) {
        this.getDynamicDealsReport(null)
      } else {
        this.getProduct();
      }

      this.search = '';
    }
    else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      if (index == 1) {
        this.redirected = false;
        let localtion = this.router.url;
        const questionMarkIndex = localtion.indexOf('?');



        if (questionMarkIndex !== -1) {
          // Extract the substring before the ?
          const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

          // Replace the original string with the substring before the ?
          localtion = beforeQuestionMark;
        }

        let url = this.router.url;
        let cleanUrl = url.split('?')[0];

        localtion = localtion.split('&page')[0]


        if (this.sortParam == undefined) {
          this.sortParam = 'updatedDate' + "," + Constant.Dsc;
        }

        //   this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

        this.redirected = false;
      }

      let val = parseInt(localStorage.getItem(Constant.SU))
      if (val > 0) {
        let searchTerm = "dealsName:" + '*' + value.trim() + '*'
          + "' AND amount:" + '*' + val + '*'
          + "' OR stage:" + '*' + value.trim() + '*' + "' "
        if (this.smartViewConditionsEnble == true) {
          this.filterActive = true;
          this.getDynamicDealsReport(this.search)
        } else {
          this.filterOption(searchTerm)
        }

      } else {
        let searchTerm = "dealsName:" + '*' + value.trim() + '*'
          + "' OR accountName:" + '*' + value.trim() + '*' + "' "
        if (this.smartViewConditionsEnble == true) {
          this.filterActive = true;
          this.getDynamicDealsReport(this.search)
        } else {
          this.filterOption(searchTerm)
        }

      }

    }
  }

  onFilterChangeColumn(i, index) {

    this.ensureSmartViewFromFilter();

    if (i == undefined) {
      this.leadIdList = [];
      this.selectionLead = [];
      this.filterActive = false
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      let location = this.router.url;
      const questionMarkIndex = location.indexOf('?');



      if (questionMarkIndex !== -1) {
        const beforeQuestionMark = location.substring(0, questionMarkIndex);
        location = beforeQuestionMark;
      }

      let url = this.router.url;
      let cleanUrl = url.split('?')[0];

      this.sortParam = 'updatedDate' + "," + Constant.Dsc;

      //  this.location.go(`${cleanUrl}`)
      if (this.smartViewConditionsEnble == true) {
        this.getDynamicDealsReport(null)
      } else {
        this.getProduct();
      }

    } else {
      i = i.replace(/'/g, '');
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      let val: any | null = null;

      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
          const userSettings = JSON.parse(decrypted);
          val = userSettings.userType;
        } catch (error) {
          console.error('Error decrypting or parsing userSettingsData:', error);
        }
      }

      if (!val) {
        const encryptedSigninDetails = localStorage.getItem('signinDetails');
        if (encryptedSigninDetails) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            val = signinDetails.userType;
          } catch (error) {
            console.error('Error decrypting or parsing signinDetails:', error);
          }
        }
      }

      if (val > 0) {
        // Only add supplier filter if not from CRM search (index != 2)
        if (index != 2) {
          i = i + " AND supplierId_cust:" + '*' + val + '*' + "'"
        }

        if (index == 1) {
          this.redirected = false;
          let localtion = this.router.url;
          const questionMarkIndex = localtion.indexOf('?');



          if (questionMarkIndex !== -1) {
            // Extract the substring before the ?
            const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

            // Replace the original string with the substring before the ?
            localtion = beforeQuestionMark;
          }

          let url = this.router.url;
          let cleanUrl = url.split('?')[0];

          localtion = localtion.split('&page')[0]


          if (this.sortParam == undefined) {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

          //    this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

          this.redirected = false;
        }
        if (this.smartViewConditionsEnble == true) {
          this.getDynamicDealsReport(i)
        } else {
          this.filterOption(i)
        }
      } else {

        if (index == 1) {
          this.redirected = false;
          let localtion = this.router.url;
          const questionMarkIndex = localtion.indexOf('?');



          if (questionMarkIndex !== -1) {
            // Extract the substring before the ?
            const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

            // Replace the original string with the substring before the ?
            localtion = beforeQuestionMark;
          }

          let url = this.router.url;
          let cleanUrl = url.split('?')[0];

          localtion = localtion.split('&page')[0]


          if (this.sortParam == undefined) {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

          //this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

          this.redirected = false;
        }
        if (this.smartViewConditionsEnble == true) {
          this.getDynamicDealsReport(i)
        } else {
          this.filterOption(i);
        }
      }

    }
  }



  exportExcel() {
    this.router.navigate([`/deals/export-deals`])
  }

  importExcel() {
    this.router.navigate([`/deals/import-deals`])
  }

  downloadReportTemplate() {
    this.dealsService.downloadProductTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  downloadTemplate1() {
    this.dealsService.downloadProductNameTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  exportGmc() {
    this.dealsService.downloadGmc().subscribe(
      data => {
        download(data);
      },
    )
  }

  sitedata() {
    this.dealsService.downloadshopdata().subscribe(
      data => {
        download(data);
      }
    )
  }

  openImportDataPopup() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductQtyAndPrice' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }


  openImportDataPopup1() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductNameAndDescription' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }

  @ViewChild('delete') delete: TemplateRef<any>;

  deleteAllDialog() {
    this.textAccount = 'OK';
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProduct() {
    if (this.textAccount === 'Processing') return;

    if (this.resourcePrivilege && this.resourcePrivilege.delete === false) {
      this.snackBar.open('You do not have permission to delete deals', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    this.textAccount = 'Processing';
    this.spinner = true;
    this.dealsService.deleteAllLead().subscribe(
      response => {
        this.spinner = false;
        this.textAccount = 'OK';
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.dialog.closeAll();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.getProduct();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      error => {
        this.spinner = false;
        this.textAccount = 'OK';
        this.snackBar.open('Error deleting deals', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }
  dateRangeValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const start = group.get('start')?.value;
    const end = group.get('end')?.value;
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
      if (diffInDays > 7) {
        return { 'exceedsMaxRange': true };
      }
    }
    return null;
  }

  @ViewChild('delete1') delete1: TemplateRef<any>;

  deleteIndividualDialog() {
    let dialogRef = this.dialog.open(this.delete1, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProductId(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.dealsService.deleteByDealsId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getProduct()
          this.cancelBulkSelection();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct(dealId, setId) {
    localStorage.setItem('dealsViewMode', this.tableViewMode || 'tableView');
    if (this.type == 1) {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
    } else {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}/${this.leadId}`])
    }
  }
  public serverPath4 = environment.commonImageApiNew
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath8 = environment.commonImageApi;

  getImage(value, images, row) {

    if (row.maintainImageIndConfProduct == 1 && row.type == 'Variants') {



      let i = 0
      let key = '';

      this.configurableProductDropdown = row['configProduct'];

      if (this.configurableProductDropdown != null) {
        for (let key of Object.keys(this.configurableProductDropdown)) {
          if (i == 0) {
            key = key;
            this.productSelected = JSON.parse(this.configurableProductDropdown[key]);

            break;
          }

        }


        // let productSelected = JSON.parse(this.configurableProductDropdown[key]);



        value = this.productSelected['productImageUrl']
        images = this.productSelected['images']
      }
      if (value == '') {
        if (images != null) {

          if (images.length > 0) {
            value = images[0]
          }



        }
      }


    }

    if (value != null) {

      if (value.includes('external')) {
        return this.serverPath8 + value;
      }
      if (value.includes('commonimages')) {
        return this.serverPath7 + value;
      }
      else if (value.includes('http')) {
        return value;
      } else if (!value.includes('medicineimages')
        && !value.includes('http')) {

        return this.serverPath + '/' + value;
      } else if (!value.includes('medicineimages')) {
        return this.serverPath4 + value;
      } else {
        return "assets/images/logo/no-image.png";
      }

    }
  }





  //seleted data

  selectionLead: any = [];
  selectedRecordMap: Map<any, any> = new Map<any, any>();
  public attributeIdList: any = [];
  public attributeListForProduct: any = [];
  @Output() onConfirAttribute: EventEmitter<any> = new EventEmitter<any>();

  checkBoxControl: UntypedFormControl = new UntypedFormControl();
  changeValue(isChecked: boolean, row) {

    if (!row || !row.entityId) return;

    if (isChecked) {
      if (!this.selectionLead.includes(row.entityId)) {
        this.selectionLead.push(row.entityId);
      }
      this.selectedRecordMap.set(row.entityId, row);

      let indexForSelection = this.leadIdList.findIndex(
        x => x.dealsOwner == row.dealsOwner && (x.leadId == row.entityId || x.entityId == row.entityId)
      );

      if (indexForSelection < 0) {
        let object = {
          'dealsOwner': row.dealsOwner,
          'leadId': row.entityId,
          ...row
        };
        this.leadIdList.push(object);
        this.checkBoxControl.patchValue(row.entityId);
      } else {
        this.leadIdList[indexForSelection] = { ...this.leadIdList[indexForSelection], ...row };
      }

    } else {
      let indexForSelectedIncrementId = this.selectionLead.findIndex(x => x == row.entityId);
      if (indexForSelectedIncrementId >= 0) {
        this.selectionLead.splice(indexForSelectedIncrementId, 1);
      }
      this.selectedRecordMap.delete(row.entityId);

      let indexForSelected = this.leadIdList.findIndex(x => x.leadId == row.entityId || x.entityId == row.entityId);
      if (indexForSelected >= 0) {
        this.leadIdList.splice(indexForSelected, 1);
      }
    }

    this.onConfirAttribute.emit(this.attributeListForProduct);
  }

  selection = new SelectionModel<any>(true, [], true, (o1, o2) => o1 && o2 && (o1.entityId === o2.entityId || o1 === o2));

  isRowSelected(element: any): boolean {
    if (!element || !this.selectionLead) return false;
    return this.selectionLead.includes(element.entityId);
  }

  syncSelectionOnDataLoad() {
    if (!this.productList || !Array.isArray(this.productList)) {
      return;
    }
    if (this.selectionLead && this.selectionLead.length > 0) {
      const selectedSet = new Set(this.selectionLead);
      const matched = this.productList.filter(row => row && selectedSet.has(row.entityId));
      if (matched.length > 0) {
        this.selection.select(...matched);
        matched.forEach(row => {
          this.selectedRecordMap.set(row.entityId, row);
        });
      }
    }
  }

  getSelectedCount(): number {
    if (this.selectionLead && Array.isArray(this.selectionLead) && this.selectionLead.length > 0) {
      return this.selectionLead.length;
    }
    return this.selection?.selected?.length || 0;
  }

  isSelectionEmpty(): boolean {
    const hasLeadSelection = this.selectionLead && Array.isArray(this.selectionLead) && this.selectionLead.length > 0;
    return !hasLeadSelection && (!this.selection || this.selection.isEmpty());
  }

  attributeList: any = [];
  isAllSelected() {
    if (!this.productList || !Array.isArray(this.productList) || this.productList.length === 0) return false;
    return this.productList.every(row => row && (this.selectionLead.includes(row.entityId) || this.selection.isSelected(row)));
  }

  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  textAccount: string;
  textAccountHousing: string;

  submit() {
    this.deleteAllProduct();
  }



  submit1() {
    this.dialog.closeAll();
  }

  downloadReport(value) {

    if (value == 'full') {
      this.selectionLead = [];
    }

    this.downloadDataComplete = "Processing";
    this.dealsService.downloadProductReportPrimary(this.page, this.size, this.sortParam, this.selectionLead).subscribe(
      data => {
        this.downloadDataComplete = "OK";
        this.dialog.closeAll();
        download(data);
        this.selectionLead = [];
      },
    )
  }

  @ViewChild('download') download: TemplateRef<any>;

  openDialog() {
    let dialogRef = this.dialog.open(this.download, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  firstFormGroup = this._formBuilder.group({
    page: ['', Validators.required],
    size: ['', Validators.required],
    sort: ['', Validators.required],
    sortBy: ['0']

  });

  booleanField: any = [
    { "value": "asc", "viewValue": "ASC" },
    { "value": "desc", "viewValue": "DESC" },
  ]

  downloadData() {

    if (this.firstFormGroup.valid) {
      console.log(this.firstFormGroup);
      this.page = this.firstFormGroup.value.page;
      this.sortParam = this.firstFormGroup.value.sort.replace('$n', '');
      this.size = this.firstFormGroup.value.size;
      if (this.firstFormGroup.value.sortBy == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (this.firstFormGroup.value.sortBy == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.downloadReport('full');

    } else {
      this.firstFormGroup.markAllAsTouched();

    }
  }

  restritionPopup() {

    let dialogRef = this.dialog.open(RestrictionComponent, {
      width: '350px',
    });
  }

  details(dealId, setId) {
    localStorage.setItem('dealsViewMode', this.tableViewMode || 'tableView');
    this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
  }

  @Input() removeColummn: any = ['attributeSetId', 'productId', 'contactName', 'accountName', 'attributeSetName', 'campaignSource', 'dealsStatus', 'statusColor', 'statusOrder',
    'dateField', 'day', 'ownerId', 'description', 'email', 'entityId', 'expectedRevenue', 'isCustomizedValue',
    'isCustomizedValueString', 'jsonRecieved', 'leadSource', 'month', 'phoneNumber', 'probability', 'roleName', 'sku', 'statusId',
    'tenantId', 'type', 'ast', 'additionalSpec', 'values', 'valuesString', 'activityCountOnLead',
    'Campaign Source', 'Contact Name', 'descriptionInformation', '', 'Lead Source', 'Next Step',
    'Reason For Loss', 'empty', 'facetFields', 'facetPivotFields', 'facetQueryResult', 'numberOfElements', 'year',];

  filterSelectObj1 = [
    {
      name: 'Name',
      property: 'dealsName',
      type: 'text',
      position: 'firstValue',
      options: []
    },
    {
      name: 'Email',
      property: 'email',
      type: 'text',
      position: 'secondValue',
      options: []
    },
    {
      name: 'Phone No',
      property: 'phoneNumber',
      type: 'text',
      position: 'thirdValue',
      options: []
    },
    {
      name: 'Deal Stage',
      property: 'stage',
      type: 'multiSelect',
      position: 'fourthValue',
      options: [],
      display: true
    },
    {
      name: 'Owner',
      property: 'ownerId',
      type: 'multiSelect',
      position: 'fifthValue',
      options: [],
      display: true
    },
    {
      name: 'created Date',
      property: 'createdDate',
      type: 'date',
      position: 'sixthValue',
      options: []
    },

    {
      name: 'updated Date',
      property: 'updatedDate',
      type: 'date',
      position: 'seventhValue',
      options: []
    },

    {
      name: 'Follow Up Date',
      property: 'followUpDateTime',
      type: 'date',
      position: 'eighthValue',
      options: []
    },
  ]
  refresh() {
    this.clearFilter();
    this.activeTab = 'all';

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
    localStorage.removeItem('dealsSmartViewConditionsEnble');
    localStorage.removeItem('smartViewConditionsEnble');
    this.loaderService.show();
    this.smartViewConditionsEnble = false;
    this.onFilterChangeColumn(undefined, 1)
    this.selection.clear();
    this.selectionLead = [];

    this.clearValue();
  }

  exportDataFilter() {
    if (window.innerWidth < 768) {
      let objToSend = this.filterSelectObj;

      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        maxWidth: '100vh',
        height: '100vh',
        width: '100%', disableClose: true,
        data: {
          url: 'getDealsBySearch',
          obj: objToSend,
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: false,
          url2: 'getDealsSelected',
          header: ['Name', 'Email', 'Phone No', 'Status Name', 'created Date', 'updated Date', 'Follow Up Date'],
          service: 'dealsService',
          headerName: 'Deals Download',
          dowloadFileName: 'Deals'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {
          this.selection.clear();
        }
      });
    }
    else {
      let objToSend = this.filterSelectObj;

      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        height: '400px',
        disableClose: true,
        data: {
          url: 'getDealsBySearch',
          obj: objToSend,
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: false,
          url2: 'getDealsSelected',
          header: ['Name', 'Email', 'Phone No', 'Status Name', 'Source Name', 'Owner', 'Activity Count', 'created Date', 'updated Date', 'Country', 'City', 'State', 'Campaign Name', 'adName'],
          service: 'dealsService',
          headerName: 'Deals Download',
          dowloadFileName: 'Deals'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {
          this.selection.clear();
        }
      });
    }
  }



  getAllLeadAdvanceFilter(search) {

    this.smartViewConditionsEnble = false;
    localStorage.removeItem("dealsSmartViewConditionsEnble");
    localStorage.removeItem("dealsSmartViewConditions");

    let sortParam: any = 'a.updatedDate' + "," + Constant.Dsc;

    if (this.advance.conditions !== null && this.advance.conditions !== undefined && this.advance.conditions !== '') {
      this.condition = this.advance.conditions;
    } else {
      this.condition = JSON.parse(localStorage.getItem('filtercondition'));
    }

    this.advanceFilterEnble = localStorage.getItem('advanceFilterEnble') === 'true';


    if (this.advanceFilterEnble == true) {

      this.filterActive = false;
      this.spinner = true;
      this.leadActivityService.searchLeadAdvanceFilterNew(search, this.page, this.size, sortParam, this.condition).subscribe(
        res => {
          this.spinner = false;
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.productList.sort = this.sort;
          this.productList.paginator = this.paginator;
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);

          console.log(this.productList);

        },
        () => {
          this.spinner = false;
        }
      )
    }
    else {
      this.filterOption(search);
    }
  }

  advance: any = [];
  condition: any;


  advanceFilterEnble: boolean = false
  exportDataFilterSelected(type) {

    if (type == 'selected') {
      const selectedMapRecords = Array.from(this.selectedRecordMap.values());
      const selectedRows: any[] = selectedMapRecords.length > 0
        ? selectedMapRecords
        : (this.selection?.selected || []);

      if ((!selectedRows || selectedRows.length === 0) && (!this.leadIdList || this.leadIdList.length === 0)) {
        return;
      }

      let value = ['Company', 'Deals Name', 'Amount', 'Stage',
        'Balance', 'Closing Date', 'Created Date', 'Updated Date', 'paymentStatus',
        'paid', 'dealsOwner', 'leadCreatedDate', 'lostReason'];

      const dataToDownloadRaw = selectedRows.length > 0
        ? selectedRows
        : this.leadIdList;

      const dataToDownload = (dataToDownloadRaw || []).map(record => {
        let downloadRecord = record.downloadList ? { ...record.downloadList } : { ...record };
        downloadRecord['Company'] = record.company || downloadRecord['Company'] || record.isCustomizedValue?.Company || record.isCustomizedValue?.company || '';
        downloadRecord['Deals Name'] = record.dealsName || downloadRecord['Deals Name'] || downloadRecord['Deal Name'] || record.dealName || '';
        downloadRecord['Amount'] = record.amount !== undefined ? record.amount : (downloadRecord['Amount'] || '');
        downloadRecord['Stage'] = record.stage || downloadRecord['Stage'] || '';
        downloadRecord['Balance'] = record.balance !== undefined ? record.balance : (downloadRecord['Balance'] || '');
        downloadRecord['Closing Date'] = record.closingDate || downloadRecord['Closing Date'] || '';
        downloadRecord['Created Date'] = record.createdDate || downloadRecord['Created Date'] || '';
        downloadRecord['Updated Date'] = record.updatedDate || downloadRecord['Updated Date'] || '';
        downloadRecord['paymentStatus'] = record.paymentStatus || downloadRecord['paymentStatus'] || '';
        downloadRecord['paid'] = record.paid !== undefined ? record.paid : (downloadRecord['paid'] || '');
        downloadRecord['dealsOwner'] = record.dealsOwner || downloadRecord['dealsOwner'] || record.ownerName || '';
        downloadRecord['leadCreatedDate'] = record.leadCreatedDate || downloadRecord['leadCreatedDate'] || '';
        downloadRecord['lostReason'] = record.lostReason || downloadRecord['lostReason'] || '';
        if (downloadRecord['LeadName']) {
          delete downloadRecord['LeadName'];
        }

        return { ...record, downloadList: downloadRecord };
      });

      this.commonService.downloadDataFinal(dataToDownload, value, 'Deal Download', false);


    } else {
      let i = 0;
      let ownerText = "leadId:*"
      let leadText = "entityId:*"
      this.leadIdList.forEach(element => {
        if (i == 0) {

          leadText = leadText + element.leadId + ",";
        } else {

          leadText = leadText + "," + element.leadId;
        }

        i++;
      });

      let finalText = (leadText || '').replace(/,,/g, ',');


      console.log(finalText);

      this.selectUpload = true;

      if (this.advanceFilterEnble == true) {
        this.getAllLeadAdvanceFilter(finalText)
      } else if (this.smartViewConditionsEnble == true) {
        this.getDynamicDealsReport(finalText)
      } else {
        this.filterOption(finalText);
      }

    }

    this.selection.clear();

  }
  transferLead() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "dealsOwners": this.leadIdList,
          "leadIds": this.selectionLead,
          "typeData": 2
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.DetectingRequestType();
          this.leadIdList = [];
          this.selectionLead = [];
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "dealsOwners": this.leadIdList,
          "leadIds": this.leadIdList,
          "typeData": 2
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.DetectingRequestType();
          this.leadIdList = [];
          this.selectionLead = [];
        }
      });
    }
  }

  downloadDataFinal(downLoadData) {
    if (this.router.url.includes('/deals')) {
      downLoadData = downLoadData
        .filter(record => record.downloadList != null)
        .map(record => record.downloadList);
    }



    if (this.removeColumn.length > 0) {
      downLoadData = this.removeColumn(downLoadData)
    }



    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    if (this.useDefaultHeading) {
      XLSX.utils.sheet_add_aoa(ws, []);
      XLSX.utils.sheet_add_json(ws, downLoadData, {
        origin: 'A2',
        skipHeader: true
      });

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let filename = 'Deals' + '.xlsx'
      XLSX.writeFile(wb, filename);
    } else {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(downLoadData);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      let filename = 'Deals' + '.xlsx'
      XLSX.writeFile(wb, filename);
    }
    this.selectionLead = [];
    this.selectUpload = false;
    this.leadIdList = [];
    if (this.GridType == 8) {
      this.getProduct();
    }


  }


  removeColumn(downloadData) {

    this.downloadData = downloadData.map(obj => {
      for (const column of this.removeColummn) {
        delete obj[column];
      }
      return obj;
    });


    return this.downloadData;

  }



  deleteSelectedLead() {
    this.deleteAllProductSelecteds();
  }


  deleteAllProductSelecteds() {
    if (this.textAccount === 'Processing') return;

    if (this.resourcePrivilege && this.resourcePrivilege.delete === false) {
      this.snackBar.open('You do not have permission to delete deals', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    if (!this.selectionLead || this.selectionLead.length === 0) {
      this.snackBar.open('No deals selected', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    this.textAccount = 'Processing';
    this.spinner = true;
    this.dealsService.deleteBySelectedId(this.selectionLead).subscribe(
      response => {
        this.spinner = false;
        this.textAccount = 'OK';
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.dialog.closeAll();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.getProduct();
          this.cancelBulkSelection();
          this.leadIdList = [];
          this.checkBoxControl.reset();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      error => {
        this.spinner = false;
        this.textAccount = 'OK';
        this.snackBar.open('Error deleting selected deals', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }

  deleteAllProductSelected() {

    if (this.resourcePrivilege?.delete && this.selectionLead.length > 0) {


      this.spinner = true;

    }

  }

  deleteSelectedDealsAll() {
    this.deleteAllSelectedsDeals();
    this.dialog.closeAll();
  }


  deleteAllSelectedsDeals() {

    if (this.resourcePrivilege?.delete && this.selectionLead.length > 0) {


      this.spinner = true;
      this.dealsService.deleteByAllSelectedDealsId(this.selectionLead).subscribe(
        response => {
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.getProduct()
            this.cancelBulkSelection();

            this.leadIdList = [];
            this.checkBoxControl.reset();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        error => {
          this.spinner = false;
        })

    }
  }

  deleteAllDealsSelected() {

    if (this.resourcePrivilege?.delete && this.selectionLead.length > 0) {


      this.spinner = true;

    }

  }
  @ViewChild('deleteSelected') deleteSelected: TemplateRef<any>;
  deleteSelectedDialog() {
    this.textAccount = 'OK';
    let dialogRef = this.dialog.open(this.deleteSelected, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }


  leadIdList: any = [];

  importExcelAdvance() {
    this.router.navigate([`deals/xlMapper`])
  }

  addPayment(row) {

    this.paymentModel(row);

  }


  paymentModel(row) {
    const balance = (row && row.balance !== undefined && row.balance !== null)
      ? Number(row.balance)
      : (Number(row?.amount || 0) - Number(row?.paid || 0));

    if (balance <= 0 || row?.paymentStatus == 'Paid') {
      this.snackBar.open('Payment status is already paid for the Sales', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
    } else {
      if (window.innerWidth > 768) {

        let dialogRef = this.dialog.open(AddDealsPaymentComponent, {
          width: '790px',
          data: {
            dealId: row.entityId,
            finalData: row,
          }


        });

        dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();

          this.tableViewMode = 'tableView';

        });

      }
      else {
        let dialogRef = this.dialog.open(AddDealsPaymentComponent, {
          minWidth: '100vw', height: '100vh',
          data: {
            dealId: row.entityId,
            finalData: row,
          }

        });

        dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          this.tableViewMode = 'tableView';
        });
      }
    }
  }

  ViewDealsPayment(row) {

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ViewDealsPaymentComponent, {
        width: '1000px',
        data: {
          finalData: row,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();
        this.tableViewMode = 'tableView';
      });

    }
    else {
      let dialogRef = this.dialog.open(ViewDealsPaymentComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          finalData: row,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();
        this.tableViewMode = 'tableView';
      });
    }
  }

  // Get a reference to the scrollable container element in the template
  @ViewChild('stepsWrapper') stepsWrapper!: ElementRef<HTMLDivElement>;

  // Flags to disable/enable arrow buttons
  isAtStart = true;
  isAtEnd = false;

  // Sample data for the setup guide steps
  setupSteps: any[] = [
    //{ id: 1, icon: 'auto_awesome', label: 'Personalize your CRM', status: 'active' },
    // { id: 2, icon: 'download', label: 'Import Deals', status: 'pending' },
    // { id: 3, icon: 'language', label: 'Bring in website leads', status: 'completed' },
    // { id: 4, icon: 'person_add', label: 'Invite your team', status: 'pending' },
    // { id: 5, icon: 'alt_route', label: 'Route leads to your team', status: 'pending' },
    // { id: 6, icon: 'track_changes', label: 'Set up goals', status: 'pending' },
    // { id: 7, icon: 'phone_in_talk', label: 'Configure phone', status: 'pending' },
    // { id: 8, icon: 'mail', label: 'Connect your email', status: 'pending' },
  ];

  onStepClick(step: any) {
    if (step.label === 'Personalize your CRM') {
      this.openBusinessEditDialog();
    }
    else if (step.label === 'Import Deals') {
      this.importExcelAdvance();
    }

    else {
      //console.log('Clicked step:', step);
    }
  }


  openBusinessEditDialog(): void {
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        width: '800px',
        panelClass: 'business-edit-dialog',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {
          window.location.reload();
          console.log("here dialog close");

        }
      });
    } else {

      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        minWidth: '100vw', height: '100vh',
        panelClass: 'business-edit-dialog',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {
          window.location.reload();
          console.log("here dialog close");

        }
      });

    }

  }

  scroll(direction: 'left' | 'right'): void {
    const element = this.stepsWrapper.nativeElement;
    // Scroll by 80% of the container's width for a smooth page-like scroll
    const scrollAmount = element.clientWidth * 0.8;

    if (direction === 'left') {
      element.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      element.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    // We need to wait for the smooth scroll to finish before checking the position.
    // A timeout is a simple way to approximate this.
    setTimeout(() => this.checkScrollPosition(), 500);
  }
  checkScrollPosition(): void {
    const { scrollLeft, scrollWidth, clientWidth } = this.stepsWrapper.nativeElement;
    this.isAtStart = scrollLeft === 0;
    // Check if we are at the end (with a small tolerance for fractional pixels)
    this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  @Input() viewMode: 'compact' | 'comfortable' = 'compact';

  @Input() tableViewMode: 'tableView' | 'kanbanView' = 'kanbanView';

  setView(mode: 'compact' | 'comfortable') {
    this.viewMode = mode;
  }

  setTableView(mode) {
    this.tableViewMode = mode;
    localStorage.setItem('dealsViewMode', mode);
  }

  applyFiltersAndClose(): void {
    this._buildAndFetchFilters();
    this.isFilterPanelOpen = false;
  }


  isFilterPanelOpen = false;
  rowLeft: string = "100";
  rowRight: string = "30";
  rowgap: string = "0px";
  isGridVisible: boolean = true;

  activeFilters: any[] = [];
  appliedFilterCount = 0;
  private filterQuery: string | null = null;
  toggleFilterPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }

    this.isFilterPanelOpen = !this.isFilterPanelOpen;

    if (this.isFilterPanelOpen) {
      this.isFilterPanelColumnOpen = false;
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  addFilter(): void {
    this.activeFilters.push({ field: '', value: '' });
  }

  removeFilter(index: number): void {
    this.activeFilters.splice(index, 1);
    this._buildAndFetchFilters();
  }
  private _buildAndFetchFilters(): void {
    const queryParts = this.activeFilters
      .filter(f => f.field && f.value)
      .map(f => `${f.field}:*${f.value}*`);
    this.filterQuery = queryParts.length > 0 ? queryParts.join(' AND ') : null;
    this.appliedFilterCount = queryParts.length;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.page = 0;
    if (queryParts.length > 0) {
      this.getLeadsFilter(); // Hypothetical method if filters exist
    } else {
      this.getProduct(); // Called when no filters are present
    }
  }

  todayDate: Date = new Date();

  getLeadsFilter() {

    const formattedDate = this.todayDate.toISOString().split('T')[0];

    this.search = `createdDate:*${formattedDate}~${formattedDate}*`;

    let url = this.router.url;
    if (url.includes('deals')) {
      let cleanUrl = url.split('?')[0];
      if (this.search) {
        localStorage.setItem(cleanUrl + "se", this.search);
      } else {
        localStorage.removeItem(cleanUrl + "se");
      }
    }

    this.dealsService.getDealsBySearchMain(this.search, this.page, this.size, this.sortParam, this.leadId).subscribe(
      res => {
        this.spinner = false;


        if (!this.selectUpload) {
          this.totalElements = res['totalElements'];
          this.totalLeadCount = res['totalElements'];
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          this.productList.sort = this.sort;
          this.pageList = res['totalElements'];
          this.newContactCount = res['totalElements'];
          this.productList.paginator = this.paginator;
          this.pageSizeValue = LeadgetPageSize(this.pageList)

        } else {
          this.downloadDataFinal(res['content'])
        }

      },
      error => {
        this.spinner = false;
      })
  }

  activeTab: any = 'all';

  onTabClick(tab: 'all' | 'new', event: Event): void {

    event.preventDefault();

    this.clearFilter();

    this.activeTab = tab;

    if (tab === 'new') {
      this.filterQuery = 'statusName:*New,*';
      this.page = 0;
      this.smartViewConditionsEnble = false;
      localStorage.removeItem("dealsSmartViewConditionsEnble");
      localStorage.removeItem("dealsSmartViewConditions");
      this.getLeadsFilter();
    } else if (tab === 'all') {
      this.page = 0;
      this.smartViewConditionsEnble = false;
      localStorage.removeItem("dealsSmartViewConditionsEnble");
      localStorage.removeItem("dealsSmartViewConditions");
      this.getProduct();
    }
  }

  masterToggle() {
    if (!this.productList || !Array.isArray(this.productList)) {
      return;
    }

    if (this.isAllSelected()) {
      this.productList.forEach(row => {
        if (!row) return;
        this.selection.deselect(row);
        let idIndex = this.selectionLead.indexOf(row.entityId);
        if (idIndex >= 0) {
          this.selectionLead.splice(idIndex, 1);
        }
        this.selectedRecordMap.delete(row.entityId);
        let listIndex = this.leadIdList.findIndex(x => x.leadId == row.entityId || x.entityId == row.entityId);
        if (listIndex >= 0) {
          this.leadIdList.splice(listIndex, 1);
        }
      });
      return;
    }

    this.productList.forEach(row => {
      if (!row || !row.entityId) return;
      this.selection.select(row);
      if (!this.selectionLead.includes(row.entityId)) {
        this.selectionLead.push(row.entityId);
      }
      this.selectedRecordMap.set(row.entityId, row);
      let listIndex = this.leadIdList.findIndex(x => x.leadId == row.entityId || x.entityId == row.entityId);
      if (listIndex < 0) {
        this.leadIdList.push({
          'dealsOwner': row.dealsOwner,
          'leadId': row.entityId,
          ...row
        });
      } else {
        this.leadIdList[listIndex] = { ...this.leadIdList[listIndex], ...row };
      }
    });
  }

  selectAllForBulkAction() {
    this.masterToggle();
  }

  allColumns: { key: string; name: string; }[] = [
    { key: 'name', name: 'dealsName' },
    { key: 'customValuesIsAccount', name: "Account" },
    { key: 'customValuesIsJob', name: "Job_Title" },
    { key: 'phoneNumber', name: 'Mobile' },
    { key: 'email', name: 'Email' },
    { key: 'statusName', name: 'Status' },
    { key: 'sourceName', name: 'Lead Source' },
    { key: 'ownerIdName', name: 'Sales Owner' },
    { key: 'createdDate', name: 'Created Date' },
    { key: 'updatedDate', name: 'Last Updated' },
    { key: 'lastActivityNotes', name: 'Last Activity' },
    { key: 'Tags', name: 'Tags' },
    { key: 'entityId', name: 'ID' }
  ];
  defaultColumns: string[] = ['select', 'name', 'customValuesIsAccount', 'customValuesIsJob', 'email', 'phoneNumber', 'statusName', 'Tags', 'ownerIdName', 'actions'];
  displayedColumns: string[] = ['select', 'name', 'customValuesIsAccount', 'customValuesIsJob', 'email', 'phoneNumber', 'statusName', 'Tags', 'ownerIdName', 'actions'];
  dataSource = new MatTableDataSource<any>([]);

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAdjustedColor(
    color: string,
    targetLightness: number,
    saturationAdjustmentFactor: number = 0
  ): string {
    const hex = this.parseColorToHex(color);

    const r = parseInt(hex.substring(1, 3), 16) / 255;
    const g = parseInt(hex.substring(3, 5), 16) / 255;
    const b = parseInt(hex.substring(5, 7), 16) / 255;

    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h: number = 0,
      s: number,
      l: number = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    const targetL = targetLightness / 100;

    const blendFactor = 0.6;
    let newL = l + (targetL - l) * blendFactor;


    newL = Math.max(0, Math.min(1, newL));
    let newS = s;
    if (newL * 100 > 90 && s > 0.1) { // Only adjust if not already desaturated

      const lightnessProximityToWhite = (newL * 100 - 90) / 10;
      newS = s * (1 - lightnessProximityToWhite * saturationAdjustmentFactor);
      newS = Math.max(0, newS);
    }


    return `hsl(${(h * 360).toFixed(0)}, ${(newS * 100).toFixed(0)}%, ${(newL * 100).toFixed(0)}%)`;
  }


  private parseColorToHex(color: string): string {

    const div = document.createElement('div');
    div.style.color = color;
    document.body.appendChild(div);


    const computed = window.getComputedStyle(div).color;
    document.body.removeChild(div);

    const rgb = computed.match(/\d+/g).map(Number);
    return '#' + rgb.map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }

  cancelBulkSelection() {
    this.selection.clear();

    this.selectionLead = [];
    this.leadIdList = [];
    this.selectedRecordMap.clear();
  }

  handlePageEvent(event: PageEvent): void {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getProduct();
  }
  announceSortChange(sortState: Sort): void {
    if (sortState.active != 'categoryNames' && sortState.active != 'icons' && sortState.active != 'select' && sortState.active != 'actions') {
      const customCol = this.allColumns.find(c => c.key === sortState.active);

      if (sortState.direction) {
        // Handle customValue key
        if (customCol && customCol.key.includes('customValue')) {
          this.sortParam = `${customCol.name}_cust,${sortState.direction}`;
        } else {
          this.sortParam = `${sortState.active},${sortState.direction}`;
        }
      } else {
        this.sortParam = 'createdDate,desc';
      }

      this.page = 0;
      this.getProduct();
    }
  }

  addColumn(columnKey: string): void {
    if (!this.displayedColumns.includes(columnKey)) {
      const actionIndex = this.displayedColumns.indexOf('actions');
      this.displayedColumns.splice(actionIndex, 0, columnKey);
      this.saveColumnPreferences(); // MODIFIED: Save after adding
    }
  }
  pageSizeOptions: number[] = [10, 25, 50, 100];

  saveColumnPreferences(): void {
    localStorage.setItem('leadsDisplayedColumns', JSON.stringify(this.displayedColumns));
  }

  getAvailableColumns(): { key: string; name: string; }[] {
    return this.allColumns.filter(col => !this.displayedColumns.includes(col.key));
  }

  removeColumnTwo(columnKey: string): void {
    this.displayedColumns = this.displayedColumns.filter(key => key !== columnKey);
    this.saveColumnPreferences(); // MODIFIED: Save after removing
  }

  getInitialsTwo(name: string | null): string {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }

  editingCell: { rowId: any; colProperty: string } | null = null;

  editingElement: any = null;
  editingCol: any = null;

  customValue: boolean;
  lastValue: any;

  startEdit(rowId: any, colProperty: string, element: any, col: any) {

    if (col.property.includes("customValuesIs")) {

      this.customValue = true;

    } else {
      this.customValue = false;
    }

    this.backupValue(colProperty, element);

    this.lastValue = element[colProperty];

    let fieldMeta = null;

    if (this.customValue) {

      let property = col.propertyName + "_cust";

      fieldMeta = this.filterSelectObj.find(f => f.property === property);

    } else {
      fieldMeta = this.filterSelectObj.find(f => f.property === colProperty);
    }

    if (fieldMeta) {
      col.inputType = fieldMeta.type || 'text';

      if (col.inputType === 'multiSelect' || col.inputType === 'multiselect') {

        col.inputType = 'select';
      }

      col.options = fieldMeta.options || [];
    } else {
      col.inputType = 'text';
      col.options = [];
    }

    this.editingCell = { rowId, colProperty };
    this.editingElement = element;
    this.editingCol = col;
  }

  stopEdit() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
  }

  closeEdit(leadId, key, value, element) {

    const backup = this.previousValues[key];

    element[key] = backup;

    this.clearValue();
  }

  clearValue() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    this.notifyKanbanUpdate();
  }

  previousValues: { [key: string]: any } = {};

  backupValue(key: any, element: any) {
    this.previousValues[key] = element[key];

  }

  saveEdit(leadId, key, value, element) {

    let object: any = {
      entityId: leadId,
    };

    if (key === 'Related Account') {
      object['Company'] = element['Company'];
      object['CompanyId'] = element['CompanyId'];
    }

    else if (key === 'Related Lead') {
      object['LeadId'] = element['LeadId'];
      object['LeadName'] = element['LeadName'];

    }
    else if (key === 'stage') {
      object['Stage'] = value;
    } else if (key === 'company') {
      object['Company'] = value;
    } else {
      object[key] = value;
    }

    this.dealsService.editLead(object, leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.editingCell = null;
          this.editingElement = null;
          this.editingCol = null;
          this.selectionLead = [];
          this.selection.clear();

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
      });

  }


  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;
  filtereddropdownTypeList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();
  protected _onDestroy1 = new Subject<void>();



  getUserDropDownList() {

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    // console.log(val);

    if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    } else {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  openLeadPanel(element: any) {
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(DealEditPageComponent, {
        width: '80%',
        maxWidth: '1200px',
        height: '100%',
        data: {
          currentId: element.entityId,
          allIds: (this.productList && Array.isArray(this.productList)) ? this.productList.map((x: any) => x.entityId) : (this.productList?.data ? this.productList.data.map((x: any) => x.entityId) : []),
          data: element
        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false,
        autoFocus: false
      });
    } else {
      const dialogRef = this.dialog.open(DealEditPageComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        data: {
          currentId: element.entityId,
          allIds: (this.productList && Array.isArray(this.productList)) ? this.productList.map((x: any) => x.entityId) : (this.productList?.data ? this.productList.data.map((x: any) => x.entityId) : []),
          data: element
        },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false,
        autoFocus: false
      });
    }
  }

  goToDeal(element: any) {
    this.openLeadPanel(element);
  }

  phonewhatsapp(data) {
    let message = `Hi ${data.dealsName || ''};`
    let url = `https://api.whatsapp.com/send?phone=${encodeURIComponent(data.phoneNumber || '')}&text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  phoneNumbercall(data) {

    if (this.dialerType == 1) {
      this.leadActivityService.makeCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {

        });
    }
    else if (this.dialerType == 2) {
      this.opendialCall(data)
      this.callANumber(data, data.phoneNumber)
    }

    else if (this.dialerType == 3) {

      this.loaderService.show();

      this.leadActivityService.makeDooctiClickToCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

      this.spinner = false;



    }
    else if (this.dialerType == 5 || this.dialerType == 9) {
      this.loaderService.show();
      this.leadActivityService.makeTelecmi(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else if (this.dialerType == 6) {
      this.loaderService.show();
      this.leadActivityService.clickToCallAcefone(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else {

      this.loaderService.hide();

      let phonenumber;

      if (data.phoneNumber.includes('+')) {
        phonenumber = "tel:" + data.phoneNumber;
      } else {
        phonenumber = "tel:+" + data.phoneNumber;
      }

      window.location.href = phonenumber;

    }
  }

  dialerShow: boolean = false;

  opendialCall(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }

  dialClose() {
    document.getElementById("mydailer").style.display = "none";
    this.dialerShow = false;
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    // console.log(number);

    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');
  }


  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://crm-app.doocti.com') {
      return;
    }

    // console.log('Received message from iframe:', event.data);
  }

  openEmailPopup(element: any) {
    const dialogRef = this.dialog.open(EmailPopupComponentComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        email: element.email,
        name: element.name,
        leadId: element.entityId,
        type: 2
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: false
    });
  }




  createNote(note: any, noteId: any, leadId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": leadId,
          "note": note,
          "noteId": noteId,
          "type": 3,
          "designType": 1,
          "title": " Add Notes to your deals!"
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          // this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": leadId,
          "note": note,
          "noteId": noteId,
          "type": 3,
          "designType": 1,
          "title": " Add Notes to your deals!"
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

        }

      });
    }
  }

  taskType = 2;
  addLeadActivity(activityType: string, activityId, leadObject: any, leadId: any) {
    if (window.innerWidth > 768) {
      let dialogConfig: any = {
        disableClose: true,
        data: {

          activityType: activityType,
          type: "deals",
          leadId: leadId,
          activityId: activityId,
          leadObject: leadObject,
          templateDisplayed: this.templateDisplayed,
          taskSaveType: 3
        }
      };

      if (this.taskType === 2) {
        dialogConfig.width = "400px";   // set width (can be 100% if you want full width)
        dialogConfig.height = "100%";   // full height
        dialogConfig.position = { right: "0", top: "0" };
        dialogConfig.panelClass = "right-slide-dialog"; // add custom animation
      } else {
        // Normal centered dialog
        dialogConfig.width = "790px";
      }

      let dialogRef = this.dialog.open(ConversationPopupComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result?.event === "add") {
          this.getProduct();
        }
      });
    }

    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          activityType: activityType,
          type: "deals",
          leadId: leadId,
          activityId: activityId,
          leadObject: leadObject,
          templateDisplayed: this.templateDisplayed,
          taskSaveType: 3
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          // this.getAllLeadActivity(this.leadId);
          this.getProduct();

        }


      });
    }

  }


  createFile(note: any, noteId: any) {
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "note": note,
        "noteId": noteId,
        "type": 3,
        "designType": 1,
        "title": "Attach Document"
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
      }
    });
  }


  getLeadNote(leadId) {

    this.crmNoteService.getAllNoteByLeadId(leadId, "3").subscribe(
      res => {
        this.noteList = res;

        //    console.log(this.noteList);


      },
      error => {

      }
    )
  }

  onCompanySelected(event, option, element) {
    if (event.isUserInput != false) {

      element['CompanyId'] = option.entityId;
      element['Company'] = option.name;


    }
  }


  companyList: any;

  getCompanyData(value) {

    if (value != '') {

      let sortParam = 'updatedDate' + "," + Constant.Dsc;

      let search = "name:" + '*' + value.trim() + '*'
        + "' OR phoneNumber:" + '*' + value.trim() + '*'
        + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


      this.companiesService.getCompanyBySearch(search, this.page, this.size, sortParam).subscribe(
        res => {

          this.companyList = res['content'];

        },
        error => {

        })


    }


  }




  getLeadData(value) {


    let sortParam = 'updatedDate' + "," + Constant.Dsc;

    let search = "name:" + '*' + value.trim() + '*'
      + "' OR phoneNumber:" + '*' + value.trim() + '*'
      + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


    this.productService.getLeadBySearch(search, this.page, this.size, sortParam).subscribe(
      res => {

        this.leadList = res['content'];




      },
      error => {

      })

  }

  onLeadSelected(event, option, element) {
    if (event.isUserInput != false) {

      element['LeadId'] = option.entityId;
      element['LeadName'] = option.name;



    }
  }


  goToMeeting() {
    const dialogRef = this.dialog.open(AddMeetingComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "type": 3
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
      }
    });
  }

  //lead status

  leadStatusList: any;
  leadStatusTypeList: any;
  filteredleadStatusTypeList: any;

  public leadStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.dealsStageService.getAllDealsStagesDropDown(4).subscribe(
      res => {
        this.leadStatusList = res;
        this.leadStatusTypeList = res;
        this.filteredleadStatusTypeList = this.leadStatusTypeList;
      },
      error => {
      }
    )
  }

  LeadStatusYFilter() {
    this.leadStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.leadStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadStatusFilterControl.value;
    if (!search) {
      this.filteredleadStatusTypeList = this.leadStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadStatusTypeList = this.leadStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }

  getStatusName(value: any): string {

    if (typeof value === 'string') {
      return value;
    }

    const found = this.filteredleadStatusTypeList.find(opt => opt.statusId === value);
    return found ? found.statusName : '--';
  }


  isFilterPanelColumnOpen = false;

  toggleFilterColumnPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }

    this.isFilterPanelColumnOpen = !this.isFilterPanelColumnOpen;

    if (this.isFilterPanelColumnOpen) {
      this.isFilterPanelOpen = false;
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  closePopupTwo(event) {
    if (event == true) {
      this.toggleFilterColumnPanel();
    }

  }

  closePopupNew(event) {
    if (event == true) {
      this.toggleFilterPanel();
    }
  }

  onOwnerSelected(event, option, element) {
    if (event.isUserInput != false) {

      console.log("option", option);


      element['OwnerId'] = option.entityId;
      element['OwnerName'] = option.email;
      element['Owner'] = option.email;


    }
  }


  goToLead(element) {

    if (element.leadId != null && element.leadId != 0) {

      if (element.leadId > 0) {

        this.router.navigate([`leadDetail/${element.leadId}`])

      }



    }


  }

  goToCompany(element) {

    if (element.companyId != null && element.companyId != 0) {

      if (element.companyId > 0) {

        this.router.navigate([`companiesDetail/${element.companyId}`])

      }
    }


  }



  smartViewList: any;

  getALLSmartViewsNew() {
    this.filterActive = false;
    this.spinner = true;
    this.smartViewsService.getSmartViewsDropDownType(2).subscribe(
      res => {
        this.spinner = false;
        this.smartViewList = res;
      },
      () => {
        this.spinner = false;
      }
    )
  }

  smartView: any;

  onClickTabData(tab: any) {
    this.clearFilter();
    this.activeTab = tab.tabName;
    localStorage.setItem(tab.tabName, tab.conditions);
    localStorage.setItem('dealsSmartViewConditionsEnble', 'true');
    localStorage.setItem("dealsActiveTab", tab.tabName);
    this.smartViewConditionsEnble = true;
    this.page = 0;
    this.getDynamicDealsReport(null);
  }


  getDynamicDealsReport(search) {

    if (search == null || search == undefined || search == '') {
      this.filterActive = false;
    }

    this.spinner = true;
    let dealsActiveTab = localStorage.getItem("dealsActiveTab")
    let conditonValue = localStorage.getItem(dealsActiveTab)
    this.dealsService.searchDealsAdvanceSmartViewFilter(search, this.page, this.size, this.sortParam, conditonValue).subscribe(
      res => {
        this.spinner = false;
        this.productList = new MatTableDataSource();
        this.elements = res['numberOfElements'];
        this.productList = res['content'];
        this.productList.sort = this.sort;
        this.productList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = LeadgetPageSize(this.pageList);
      },
      () => {
        this.spinner = false;
      }
    )
  }

  ensureSmartViewFromFilter(): void {


    let dealsActiveTab = localStorage.getItem("dealsActiveTab");


    if (dealsActiveTab == null) {
      this.smartViewConditionsEnble = false;
      return
    }



    let dealsSmartViewConditions = localStorage.getItem(dealsActiveTab);

    if (dealsActiveTab != null && dealsSmartViewConditions != null) {

      this.activeTab = dealsActiveTab;
      this.smartViewConditionsEnble = true;
      return;
    } else {
      this.smartViewConditionsEnble = false;
      return
    }






  }

  clearFilter() {

    let dealsActiveTab = localStorage.getItem("dealsActiveTab");;

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl + "se");

    localStorage.removeItem(dealsActiveTab);
    localStorage.removeItem('dealsSmartViewConditionsEnble');
    localStorage.removeItem("dealsActiveTab");

  }

  private scrollAndActivateTabByLabel(labelStart: string | null | undefined, activateType?: 'all' | 'new' | 'smart' | 'none', smartData?: any) {
    if (!labelStart) return;
    try {
      const { tabItems, labels } = this.getTabItemsAndActiveIndex();
      const idx = labels.findIndex(l => l && l.toLowerCase().startsWith((labelStart || '').toLowerCase()));
      if (idx >= 0 && tabItems[idx]) {
        const targetEl = tabItems[idx];
        this.scrollToTabElement(targetEl);
      } else {

      }
    } catch (e) {

    }
  }

  private getTabItemsAndActiveIndex(): { tabItems: HTMLElement[]; labels: string[]; activeIndex: number } {
    const el: HTMLElement | undefined = this.tabsScroll?.nativeElement;
    const tabItems: HTMLElement[] = el ? Array.from(el.querySelectorAll('.tab-item')) as HTMLElement[] : [];

    const getLabel = (t: HTMLElement) => {
      const textNode = Array.from(t.childNodes).find(n => n.nodeType === Node.TEXT_NODE) as Text;
      return textNode ? (textNode.textContent || '').trim() : (t.textContent || '').trim();
    };

    const labels = tabItems.map(t => (getLabel(t) || '').trim());

    let activeIndex = tabItems.findIndex(t => t.classList.contains('active'));
    if (activeIndex === -1 && this.activeTab) {
      const lowerActive = String(this.activeTab).toLowerCase();
      activeIndex = labels.findIndex(l => l && l.toLowerCase().startsWith(lowerActive));
    }
    if (activeIndex === -1) activeIndex = 0;

    return { tabItems, labels, activeIndex };
  }

  private scrollToTabElement(el: HTMLElement) {
    const container = this.tabsScroll.nativeElement as HTMLElement;

    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    const currentScroll = container.scrollLeft;

    const elCenter =
      elRect.left - containerRect.left + currentScroll - (containerRect.width / 2) + (elRect.width / 2);

    container.scrollTo({
      left: elCenter,
      behavior: 'smooth'
    });
  }

  getAllTabs() {
    const tabs: { key: string; type: 'new' | 'all' | 'smart'; data?: any }[] = [];

    tabs.push({ key: 'all', type: 'all' });


    this.smartViewList.forEach(tab => {
      tabs.push({ key: tab.tabName, type: 'smart', data: tab });
    });

    return tabs;
  }


  scrollTabs(direction: 'left' | 'right', event: Event) {

    const tabs = this.getAllTabs();
    if (!tabs.length) return;

    const currentIndex = tabs.findIndex(t => t.key === this.activeTab);
    if (currentIndex === -1) return;

    const nextIndex =
      direction === 'right'
        ? (currentIndex + 1) % tabs.length
        : (currentIndex - 1 + tabs.length) % tabs.length;

    const nextTab = tabs[nextIndex];


    const tabElements = Array.from(
      this.tabsScroll.nativeElement.querySelectorAll('.tab-item')
    ) as HTMLElement[];

    const targetEl = tabElements.find(el =>
      el.textContent?.trim().toLowerCase() === nextTab.key.toLowerCase()
    );

    const container = this.tabsScroll.nativeElement as HTMLElement;

    if (direction === 'right' && nextIndex === 0) {
      container.scrollLeft = 0;
    }

    if (direction === 'left' && nextIndex === tabs.length - 1) {
      container.scrollLeft = container.scrollWidth;
    }

    if (nextTab.type === 'smart') {
      this.onClickTabData(nextTab.data);
    } else {
      this.onTabClick(nextTab.key as any, event);
    }

    setTimeout(() => {
      if (targetEl) {
        this.scrollToTabElement(targetEl);
      }
    });
  }

  gridList: any;

  gridColumnList: ListColumn[] = [];

  getGridById(id) {
    this.dealsGridService.getDealsGridById(id).subscribe(
      res => {
        this.gridList = res;
        this.gridColumnList = this.gridList.gridColumnList;

        if (this.gridColumnList && this.gridColumnList.length) {
          this.gridColumnList = this.gridColumnList.map((col: any) => {
            if (
              col.property === 'owner' || col.property === 'Owner' || col.property === 'ownerEmail' ||
              col.attributeCode === 'ownerEmail' || col.propertyName === 'ownerEmail'
            ) {
              col.property = 'dealsOwner';
            }
            return col;
          });

          const uniqueProps = new Set();
          this.gridColumnList = this.gridColumnList.filter(col => {
            if (!uniqueProps.has(col.property)) {
              uniqueProps.add(col.property);
              return true;
            }
            return false;
          });
        }

        if (this.gridColumnList && this.gridColumnList.length) {
          this.columns = this.gridColumnList;

          this.columns = this.gridColumnList.map(col => {
            if (col.optionValues) {
              try {
                col.optionValues = typeof col.optionValues === 'string' ? JSON.parse(col.optionValues) : col.optionValues;
              } catch (e) {
                col.optionValues = [];
              }
            }
            return col;
          });

          this.columnsProperties = this.columns.map(col => col.property);
        } else {
          console.error('No columns data found');
        }

        if (this.gridList.filterValues == "" || !this.gridList.filterValues) {
          this.buildFilterSelectObjFromColumns(this.columns);
        } else {

          let list = JSON.parse(this.gridList.filterValues);

          if (Array.isArray(list)) {
            list = list.map((item: any) => {
              if (
                item.property === 'owner' || item.property === 'Owner' || item.property === 'ownerEmail' ||
                item.attributeCode === 'ownerEmail' || item.propertyName === 'ownerEmail'
              ) {
                item.property = 'dealsOwner';
                item.type = 'multiSelect';
              }
              return item;
            });
          }

          this.filterSelectObj = list;
        }
      },
      error => {
        console.error('Error fetching grid data', error);
      }
    );
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  isStaticColumn(property: string): boolean {
    const staticCols = ['name', 'ownerEmail', 'dealsOwner', 'dealsName', 'select', 'closingDate', 'expectedClosingDate', 'leadCreatedDate', 'activityCountOnLead', 'createdDate', 'updatedDate', 'adGroupName', 'Country', 'City', 'State', 'paymentStatus', 'paid', 'balance', 'amount', 'stage', 'actions'];
    return staticCols.includes(property);
  }
}
